import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../store';

@customElement('shared-specsheet-feature')
export class SharedSpecsheetFeature extends connect(store)(LitElement) {

	static styles = css`
		:host {
			padding: 0;
			container-type: inline-size;
		}
		.row {
			display: flex;
			padding: 0.7cqw 0 0.7cqw 0;
			justify-content: flex-start;
			border-bottom: 1px solid #c6c6c6;
		}

		.label {
			font: var(--font-specsheet-print-small-bold);
			font-weight: bold;
			font-size: 2cqw;
			padding-right: 1cqw;
			white-space: nowrap;
			flex: 1;
		}

		.value {
			font: var(--font-specsheet-print-small-text);
			font-size: 2cqw;
			flex: 2;
		}

	`;

	@property({type: String})
	key = '';

	@property({type: String})
	condition = null;

	@property({type: String})
	styleChoice = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}

	render() {
		if (this.condition?.trim() === '') return null;
		return html`
			<div class="row ${this.styleChoice}">
				<span class="label">
					<slot name="label"></slot>
				</span>
				<span class="value">
					<slot name="value"></slot>
				</span>
			</div>
        `;
	}
}
